<template>
<div class="login column-me center-all">
	<div class="top-box"><img src="../assets/images/top_left.png" /></div>
	<div class="right-box"><img src="../assets/images/top_right.png" /></div>
	<div class="bottom-box"><img src="../assets/images/bottom.png" /></div>
	<div class="center-div column-me center-all">
		<!-- <div class="row-me row-center margin-top50">
		</div> -->
		<div class="login_box">
	  		<img src="../assets/images/admin_login.png"/>
		</div>
		<div class="form_box">
			<div class="card-div column-me column-center">
				<div class="top_img"><img src="../assets/images/admin_logo.png"></div>
				<div class="sec_img"><img src="../assets/images/admin_title.png"/></div>
			</div>
			<div class="card-div column-me column-center">
				<div class="item-input row-me row-center">
					<img src="../assets/images/icon-phone.png" class="img-icon margin-left20" draggable="false">
					<div class="margin-left10 flex1 margin-right10">
					<el-input ref="account" class="input-div" placeholder="请输入手机号" clearable v-model="account"
						   @keyup.enter="clickLogin"></el-input>
				</div>
			</div>
			<div class="item-input row-me row-center margin-top20">
				<img src="../assets/images/icon-password.png" class="img-icon margin-left20" draggable="false">
				<div class="margin-left10 flex1 margin-right10">
					<el-input ref="password" class="input-div" placeholder="请输入密码" type="password" clearable
						  v-model="password">
					</el-input>
				</div>
			</div>
			<div class="btn-gold btn-login" @click="clickLogin">登录</div>
		</div>
      </div>
    </div>
  </div>
</template>

<script>
//import SIdentify from '../components/sidentify/sidentify.vue'

export default {
  components: {
    //SIdentify
  },
  data() {
    return {
      account: '',
      password: '',
      code: '',
      identifyCodes: "",
      identifyCode: "",
      showRedBorder: false,
    }
  },
  // html加载完成之前
  created() {
    sessionStorage.clear()
    //localStorage.clear()
    //this.refreshCode()
  },
  // html加载完成后执行。
  mounted() {
    //this.identifyCode = "";
    //this.makeCode(this.identifyCodes, 4);
  },
  // 事件方法执行
  methods: {
    //验证码
    clickLogin() {
		if (this.account === '' || this.password === '') {
			this.showRedBorder = true
			if (this.account === '') {
				this.$refs.account.focus()
			} else if (this.password === '') {
				this.$refs.password.focus()
			} 
			return
		}	
		sessionStorage.removeItem('clickMenuUrl1')
		sessionStorage.removeItem('clickMenuUrl2')
		this.$post('login/adminlogin', {
			account: this.account,
			password: this.password,
		}).then((res) => {
			console.log(res);
			if (res) {
				sessionStorage.setItem('token', res.data.token)
				sessionStorage.setItem('acctype', res.data.acctype)
				sessionStorage.setItem('GlobalUploadUrl', 'https://system.chongfenlusvip.cn');
				//sessionStorage.setItem('GlobalUploadUrl', 'http://www.chongfenlu.com');
				sessionStorage.setItem('user', JSON.stringify(res.data.admininfo))
				this.$message.success('登录成功')
				//return;
				this.$router.replace({
					path: '/'
				})
			}
		}).catch((error) => {
			console.log(error)
		})
    }
  },
  // 计算属性
  computed: {},
  // 侦听器
  watch: {},
}
</script>

<style lang="scss" scoped>
.login {
  width: 100vw;
  height: 100vh;
  position: relative;
  background-color: #050c5b;
  background-size: 100% 100%;
  background-repeat: no-repeat;
	
	.top-box{
		position: absolute;
		left: 0;
		top: 0;
		width: auto;
		height: auto;
	}
	.top-box img{
		max-width: 100%;
		height: auto;
	}
	.right-box{
		position: absolute;
		width: auto;
		height: auto;
		top: 45%;
		right:0%;
	}
	.right-box img{
		max-width: 100%;
		height: auto;
	}
	.bottom-box{
		position: absolute;
		width: auto;
		height: auto;
		bottom:0%;
	}
	.bottom-box img{
		max-width: 100%;
		height: auto;
	}
  .center-div {
    background: rgba(255, 255, 255, 1);
	width: 1200px;
	height: 567px;
    border-radius: 15px;
	display: block;
	overflow: hidden;
	
	.form_box{
		float: left;
		width:556px;
		height:567px;
	}
	.login_box{
		float: left;
		width: 525px;
		height: 567px;
	}
	.login_box img{
		max-width: 100%;
		height: auto;
	}

    .img1 {
      width: 80px;
      height: 80px;
      object-fit: scale-down;
      border-radius: 15px;
    }

    .main-title {
      font-size: 35px;
      font-weight: bold;
      letter-spacing: 5px;
      margin-left: 20px;
      user-select: none;
    }

    .card-div {
	  float: right;
      width: 556px;
      border-radius: 15px;
      padding-top: 20px;
      padding-bottom: 20px;
	  
      .img-jian {
        width: 252px;
        height: 54px;
        object-fit: scale-down;
        margin-left: 70px;
      }

      .img-icon {
        width: 25px;
        height: 25px;
        object-fit: scale-down;
      }
		.top_img{
			margin-left: 120px;
			margin-top: 40px;
		}
		.sec_img{
			margin-top: 30px;
			margin-left: 120px;
		}
      .item-input {
        width: 420px;
        height: 61px;
        margin-left: 120px;
        border-radius: 10px;
		border: 1px solid #929bfe;

        .input-div {
          &:deep(.el-input__inner) {
            font-size: 18px;
            background: none;
            border: none;
            outline: none;
          }

          &:deep(.el-input__inner::-webkit-input-placeholder) {
            font-size: 18px;
            color: #9D9E9E;
          }
        }
      }
	
      .code-div {
        width: 270px !important;
      }

      .login-code {
        cursor: pointer;
      }

      .btn-login {
        width: 421px;
        height: 61px;
        line-height: 61px;
        text-align: center;
        border-radius: 5px;
        letter-spacing: 5px;
        font-size: 20px;
        font-weight: 500;
		background: #4a59fe;
        color: #FFFFFF;
        margin-top: 35px;
        margin-left: 120px;
		cursor: pointer;
      }

      &:deep(.el-input__wrapper) {
        box-shadow: none;
      }
    }
  }
}
</style>
